import { render } from "./ComparisonPage.vue?vue&type=template&id=5ab39982&scoped=true"
import script from "./ComparisonPage.vue?vue&type=script&lang=js"
export * from "./ComparisonPage.vue?vue&type=script&lang=js"

import "./ComparisonPage.vue?vue&type=style&index=0&id=5ab39982&scoped=true&lang=css"

import exportComponent from "/home/runner/work/mlp/mlp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ab39982"]])

export default __exports__